module.exports = __webpack_public_path__ + "assets/wio-min.327c21a38f2df05a03c5bb58971242ce.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/VictorSantacana/wio-min.jpg
 ** module id = 421
 ** module chunks = 0
 **/